<template>
  <div class="chat-messages">
    <ul class="chat-messages__container">
      <li
        v-for="(message, index) in messages"
        :key="index"
        class="chat-messages__message-container mb-2"
      >
        <MessageBalloon :message="message" @click:image="showImageViewer" />
      </li>

      <li style="height: 0; width: 0" id="lastMessage"></li>
    </ul>

    <div v-if="isViewingImage">
      <ImageViewer v-model="isViewingImage" :image="viewingImage" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Message } from "@/controller/chat";
import MessageBalloon from "./MessageBalloon.vue";
import ImageViewer from "./ImageViewer.vue";

export default defineComponent({
  name: "ChatMessages",

  components: {
    MessageBalloon,
    ImageViewer
  },

  props: {
    messages: {
      type: Array as PropType<Message[]>,
      required: true
    }
  },

  data() {
    return {
      isViewingImage: false,
      viewingImage: "",
      lastMessagesLength: 0
    };
  },

  watch: {
    messages(newMessages: Message[]) {
      const newMessagesLength = newMessages.length;

      if (newMessagesLength > this.lastMessagesLength) {
        this.lastMessagesLength = newMessagesLength;
        const lastMessage = newMessages[newMessagesLength - 1];

        if (lastMessage.isFromCustomer) {
          this.$nextTick(() => {
            this.scrollChatToBottom();
          });
        }
      }
    }
  },

  mounted() {
    this.scrollChatToBottom();
  },

  methods: {
    showImageViewer(selectedImage: string) {
      this.isViewingImage = true;
      this.viewingImage = selectedImage;
    },

    scrollChatToBottom() {
      document.getElementById("lastMessage")?.scrollIntoView();
    }
  }
});
</script>

<style lang="scss" scoped>
.chat-messages {
  height: 100%;
  background: $light-grey;
  padding: $m3 $m2;
}

.chat-messages__container {
  overflow: auto;
  max-height: 100%;
}
</style>
